/* fh-cart.js — Fiskehandleren handlekurv V3
 * AJAX qty-oppdatering uten page reload.
 */

(function () {
  'use strict';

  if (window.__fhcCartBound) return;
  window.__fhcCartBound = true;

  function postJSON(url, data, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
      var json = null;
      try { json = JSON.parse(xhr.responseText); } catch (e) {}
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(null, json);
      } else {
        callback(new Error(json && json.description ? json.description : 'HTTP ' + xhr.status), json);
      }
    };
    xhr.onerror = function () { callback(new Error('Network error'), null); };
    xhr.send(JSON.stringify(data));
  }

  function formatMoney(cents) {
    var str = (cents / 100).toFixed(2).replace('.', ',');
    var parts = str.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // narrow no-break space
    return parts.join(',') + ' kr';
  }

  // Enhetspris (oere) = variantens LISTEPRIS fra data-fhc-unit-list.
  // Brukes til optimistisk prisoppdatering saa linjeprisen foelger antallet
  // umiddelbart, i stedet for aa staa "frossen" til serveren svarer (treg mobil).
  // Vi bruker BEVISST listeprisen (udiskontert): da blir optimistisk pris enten
  // eksakt (ingen rabatt) eller litt FOR HOEY — serveren korrigerer ned til evt.
  // mengderabatt (f.eks. "Skaldyrspakke 10%" fra 3 stk). Vi viser ALDRI en for lav
  // pris. Mangler attributtet -> 0 -> hopp over optimistisk (trygt).
  function unitListOre(card) {
    var v = parseInt(card.getAttribute('data-fhc-unit-list'), 10);
    return (v && v > 0) ? v : 0;
  }

  function hideCartErrors() {
    var errors = document.querySelector('[data-cart-errors]');
    if (errors) errors.style.display = 'none';
    document.querySelectorAll('.cart__errors, .cart__error, [data-cart-error-container]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function updateCartUI(cart) {
    hideCartErrors();

    var countEls = document.querySelectorAll('[data-cart-count], .cart__items-count, .js-cart-count');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.dataset) el.dataset.cartCount = cart.item_count;
    });

    var headerBubble = document.querySelector('.cart__bubble, .header__cart-count, [data-cart-bubble]');
    if (headerBubble) headerBubble.textContent = cart.item_count;

    var titleCount = document.querySelector('[data-fhc-title-count]');
    if (titleCount) titleCount.textContent = cart.item_count;

    var asideBody = document.querySelector('[data-fhc-free-threshold]');
    var shippingCost = asideBody ? parseInt(asideBody.getAttribute('data-fhc-shipping-cost'), 10) : 13000;
    var freeThreshold = asideBody ? parseInt(asideBody.getAttribute('data-fhc-free-threshold'), 10) : 100000;
    var isFree = cart.total_price >= freeThreshold;
    var displayTotal = isFree ? cart.total_price : cart.total_price + shippingCost;

    var asideCount = document.querySelector('[data-fhc-aside-count]');
    if (asideCount) asideCount.textContent = 'Varer (' + cart.item_count + ' stk)';

    var asideSubtotal = document.querySelector('[data-fhc-aside-subtotal]');
    if (asideSubtotal) asideSubtotal.textContent = formatMoney(cart.total_price);

    var asideShipping = document.querySelector('[data-fhc-aside-shipping]');
    if (asideShipping) {
      asideShipping.innerHTML = isFree
        ? '<span class="fhc__summary-free">Gratis</span>'
        : formatMoney(shippingCost);
    }

    var asideTotal = document.querySelector('[data-fhc-aside-total]');
    if (asideTotal) asideTotal.textContent = formatMoney(displayTotal);

    // FH 2026-08-02: mobil in-flow-sammendrag (fhc__mcta)
    var mobileSubtotal = document.querySelector('[data-fhc-mobile-subtotal]');
    if (mobileSubtotal) mobileSubtotal.textContent = formatMoney(cart.total_price);
    var mobileShipping = document.querySelector('[data-fhc-mobile-shipping]');
    if (mobileShipping) {
      mobileShipping.innerHTML = isFree
        ? '<span class="fhc__summary-free">Gratis</span>'
        : formatMoney(shippingCost);
    }

    var remaining = Math.max(0, freeThreshold - cart.total_price);
    var progress = Math.min(100, (cart.total_price / freeThreshold) * 100);
    document.querySelectorAll('[data-fhc-freeship]').forEach(function (bar) {
      var textEl = bar.querySelector('[data-fhc-freeship-text]');
      var fillEl = bar.querySelector('[data-fhc-freeship-fill]');
      if (textEl) {
        if (remaining > 0) {
          textEl.innerHTML = 'Du mangler <strong>' + formatMoney(remaining) + '</strong> for gratis frakt';
          textEl.classList.remove('fhc__freeship-text--done');
        } else {
          textEl.textContent = 'Du har gratis frakt!';
          textEl.classList.add('fhc__freeship-text--done');
        }
      }
      if (fillEl) fillEl.style.width = progress + '%';
    });

    var mobileTotal = document.querySelector('[data-fhc-mobile-total]');
    if (mobileTotal) mobileTotal.textContent = formatMoney(displayTotal);

    var mobileCount = document.querySelector('.fhc__mobile-bar__count');
    if (mobileCount) mobileCount.textContent = cart.item_count + (cart.item_count === 1 ? ' vare' : ' varer');

    // Update delivery step total (Bug fix: stale price on delivery step)
    var deliveryCart = document.querySelector('[data-fh-cart-total]');
    if (deliveryCart) {
      deliveryCart.setAttribute('data-fh-cart-total', (cart.total_price / 100).toFixed(2));
      if (window.__fhDeliveryUpdateTotal) window.__fhDeliveryUpdateTotal(cart.total_price);
    }

    // Fix freeship bar visibility when crossing threshold
    var asideCard = document.querySelector('.fhc__aside-card');
    if (asideCard) {
      var freeshipSimple = asideCard.querySelector('.fhc__freeship-simple');
      var freeshipDone = asideCard.querySelector('.fhc__freeship-done');

      if (isFree) {
        if (freeshipSimple) freeshipSimple.style.display = 'none';
        if (!freeshipDone) {
          var doneHtml = '<div class="fhc__freeship-done" data-fhc-freeship>' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
            '<span data-fhc-freeship-text class="fhc__freeship-simple-text--done">Du har gratis frakt!</span></div>';
          var shippingRow = asideCard.querySelector('[data-fhc-aside-shipping-row]');
          if (shippingRow) shippingRow.insertAdjacentHTML('afterend', doneHtml);
        } else {
          freeshipDone.style.display = '';
        }
      } else {
        if (freeshipDone) freeshipDone.style.display = 'none';
        if (!freeshipSimple) {
          var simpleHtml = '<div class="fhc__freeship-simple" data-fhc-freeship>' +
            '<span class="fhc__freeship-simple-text" data-fhc-freeship-text>Du mangler <strong>' + formatMoney(remaining) + '</strong> for gratis frakt</span>' +
            '<div class="fhc__freeship-simple-bar"><div class="fhc__freeship-simple-fill" data-fhc-freeship-fill style="width:' + progress + '%"></div></div></div>';
          var divider = asideCard.querySelector('.fhc__summary-divider');
          if (divider) divider.insertAdjacentHTML('afterend', simpleHtml);
        } else {
          freeshipSimple.style.display = '';
        }
      }
    }

    // FH 2026-08-02: topp-tracker pending/done-veksling (fhc__topship)
    var topship = document.querySelector('[data-fhc-topship]');
    if (topship) {
      var tsPending = topship.querySelector('.fhc__topship-pending');
      var tsDone = topship.querySelector('.fhc__topship-done');
      if (tsPending) tsPending.style.display = isFree ? 'none' : '';
      if (tsDone) tsDone.style.display = isFree ? '' : 'none';
    }

    // Fix mobile bar freeship visibility (sticky-baren er fjernet 2026-08-02 - blokken under er no-op og ufarlig)
    var mobileBar = document.querySelector('[data-fhc-mobile-bar]');
    if (mobileBar) {
      var mobFreeshipNormal = mobileBar.querySelector('.fhc__mobile-bar__freeship:not(.fhc__mobile-bar__freeship--done)');
      var mobFreeshipDone = mobileBar.querySelector('.fhc__mobile-bar__freeship--done');

      if (isFree) {
        if (mobFreeshipNormal) mobFreeshipNormal.style.display = 'none';
        if (!mobFreeshipDone) {
          var mobDoneHtml = '<div class="fhc__mobile-bar__freeship fhc__mobile-bar__freeship--done">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
            '<span>Gratis frakt!</span></div>';
          mobileBar.insertAdjacentHTML('afterbegin', mobDoneHtml);
        } else {
          mobFreeshipDone.style.display = '';
        }
      } else {
        if (mobFreeshipDone) mobFreeshipDone.style.display = 'none';
        if (!mobFreeshipNormal) {
          var mobNormalHtml = '<div class="fhc__mobile-bar__freeship" data-fhc-freeship>' +
            '<div class="fhc__mobile-bar__freeship-track"><div class="fhc__mobile-bar__freeship-fill" data-fhc-freeship-fill style="width:' + progress + '%"></div></div>' +
            '<span class="fhc__mobile-bar__freeship-text" data-fhc-freeship-text>' + formatMoney(remaining) + ' til gratis frakt</span></div>';
          mobileBar.insertAdjacentHTML('afterbegin', mobNormalHtml);
        } else {
          mobFreeshipNormal.style.display = '';
          var mobTrackFill = mobFreeshipNormal.querySelector('.fhc__mobile-bar__freeship-fill');
          if (mobTrackFill) mobTrackFill.style.width = progress + '%';
          var mobText = mobFreeshipNormal.querySelector('.fhc__mobile-bar__freeship-text');
          if (mobText) mobText.textContent = formatMoney(remaining) + ' til gratis frakt';
        }
      }
    }

    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  /* ============================================================
     QTY CHANGE — AJAX, ingen reload
     ============================================================ */

  function handleQtyChange(target, delta) {
    var lineKey = target.getAttribute('data-line-key');
    if (!lineKey) return;

    var card = target.closest('.fhc__card, .fhc__group-compact-card');
    if (!card) return;

    var input = card.querySelector('[data-fhc-qty-input], .fhc__group-compact-qty input');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var newQty = Math.max(0, current + delta);

    input.value = newQty;

    // Optimistisk prisoppdatering: la linjeprisen foelge antallet umiddelbart.
    // Serveren reconcilierer med eksakt final_line_price naar svaret kommer.
    if (newQty > 0) {
      var _unitOre = unitListOre(card);
      if (_unitOre > 0) {
        var _pEl = card.querySelector('.fhc__price, .fhc__group-compact-price');
        if (_pEl) _pEl.textContent = formatMoney(_unitOre * newQty);
        var _cEl = card.querySelector('.fhc__qty-calc');
        if (newQty > 1) {
          if (_cEl) _cEl.textContent = newQty + ' x ' + formatMoney(_unitOre);
        } else if (_cEl) {
          _cEl.remove();
        }
      }
    }

    var qtyWrap = card.querySelector('.fhc__qty, .fhc__group-compact-qty');
    if (qtyWrap) qtyWrap.style.opacity = '0.5';

    postJSON('/cart/change.js', { id: lineKey, quantity: newQty }, function (err, cart) {
      if (err) { window.location.reload(); return; }

      if (newQty === 0) {
        var qtyGroup = card.closest('.fhc__group');
        card.style.transition = 'opacity 0.3s, transform 0.3s';
        card.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        if (qtyGroup) {
          setTimeout(function () { reloadCartSection(); }, 300);
        } else {
          setTimeout(function () { card.remove(); }, 300);
        }
      } else {
        if (qtyWrap) qtyWrap.style.opacity = '1';

        if (cart.items) {
          // Finn linja i svaret. VIKTIG: linje-noekkelen ENDRER seg naar en
          // linje-rabatt (f.eks. "Skaldyrspakke 10%") slaar inn/av ved en
          // mengde-terskel. Match derfor paa noekkel FOERST, ellers paa variant-id.
          var _vid = parseInt(lineKey.split(':')[0], 10);
          var _li = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === lineKey) { _li = cart.items[i]; break; }
          }
          if (!_li) {
            for (var j = 0; j < cart.items.length; j++) {
              if (cart.items[j].variant_id === _vid) { _li = cart.items[j]; break; }
            }
          }
          if (_li) {
            var priceEl = card.querySelector('.fhc__price, .fhc__group-compact-price');
            if (priceEl) priceEl.textContent = formatMoney(_li.final_line_price);

            var calcEl = card.querySelector('.fhc__qty-calc');
            if (newQty > 1 && calcEl) {
              calcEl.textContent = newQty + ' x ' + formatMoney(_li.final_price);
            } else if (newQty > 1 && !calcEl) {
              var prices = card.querySelector('.fhc__prices');
              if (prices) {
                var span = document.createElement('span');
                span.className = 'fhc__qty-calc';
                span.textContent = newQty + ' x ' + formatMoney(_li.final_price);
                var kgEl = prices.querySelector('.fhc__kgprice');
                if (kgEl) prices.insertBefore(span, kgEl);
                else prices.appendChild(span);
              }
            } else if (calcEl) {
              calcEl.remove();
            }

            // Re-noekkle kortets kontroller hvis noekkelen endret seg (rabatt-terskel),
            // ellers feiler NESTE antall-/fjern-klikk med utdatert noekkel (-> reload).
            if (_li.key && _li.key !== lineKey) {
              card.querySelectorAll('[data-line-key]').forEach(function (el) {
                el.setAttribute('data-line-key', _li.key);
              });
            }
          }
        }
      }

      if (cart) updateCartUI(cart);
    });
  }

  /* ============================================================
     BUNDLE CLEANUP — shared helper
     ============================================================ */

  function cleanupBundleGroup(group) {
    if (!group) return;
    var parent = group.parentNode;
    var cards = group.querySelectorAll('.fhc__group-items > .fhc__card');
    cards.forEach(function (card) {
      parent.insertBefore(card, group);
    });
    group.style.transition = 'opacity 0.25s';
    group.style.opacity = '0';
    setTimeout(function () { group.remove(); }, 250);
  }

  /* ============================================================
     REMOVE ITEM
     ============================================================ */

  function handleRemove(target) {
    var lineKey = target.getAttribute('data-line-key');
    if (!lineKey) return;

    var card = target.closest('.fhc__card, .fhc__group-compact-card');
    var isInBundle = card && card.closest('.fhc__group');

    if (card) {
      card.style.transition = 'opacity 0.3s, transform 0.3s';
      card.style.opacity = '0';
      card.style.transform = 'scale(0.9)';
    }

    postJSON('/cart/change.js', { id: lineKey, quantity: 0 }, function (err, cart) {
      if (err || !cart) { window.location.reload(); return; }
      if (cart.item_count === 0) { window.location.reload(); return; }

      if (isInBundle) {
        setTimeout(function () { reloadCartSection(); }, 300);
      } else {
        setTimeout(function () { if (card) card.remove(); }, 300);
        updateCartUI(cart);
      }
    });
  }

  /* ============================================================
     GHOST DISMISS — hide ghost, cleanup bundle if no ghosts left
     ============================================================ */

  function handleGhostDismiss(target) {
    var ghost = target.closest('.fhc__ghost, .fhc__group-compact-card--ghost');
    if (!ghost) return;
    var group = ghost.closest('.fhc__group');

    if (group) {
      var bundleId = group.dataset.bundleId || '';
      if (bundleId) {
        try { sessionStorage.setItem('fhc_dismissed_' + bundleId, '1'); } catch (e) {}
      }
      cleanupBundleGroup(group);
    } else {
      ghost.style.transition = 'opacity 0.25s';
      ghost.style.opacity = '0';
      setTimeout(function () { ghost.remove(); }, 250);
    }
  }

  /* ============================================================
     BUNDLE DISMISS — remove bundle wrapper, keep products
     ============================================================ */

  function handleBundleDismiss(target) {
    var group = target.closest('.fhc__group');
    if (!group) return;

    var bundleId = group.dataset.bundleId || '';
    if (bundleId) {
      try { sessionStorage.setItem('fhc_dismissed_' + bundleId, '1'); } catch (e) {}
    }

    cleanupBundleGroup(group);
  }

  /* ============================================================
     VARIANT SWAP — AJAX, ingen full reload
     ============================================================ */

  function handleVariantSwap(target) {
    if (target.classList.contains('is-selected')) return;

    var newVariant = target.getAttribute('data-new-variant');
    var lineKey = target.getAttribute('data-line-key');
    var qty = parseInt(target.getAttribute('data-qty'), 10) || 1;
    if (!newVariant || !lineKey) return;

    var card = target.closest('.fhc__card');
    var allChips = card ? card.querySelectorAll('[data-fhc-swap]') : [];

    var originalVid = null;
    var selected = card ? card.querySelector('[data-fhc-swap].is-selected') : null;
    if (selected) originalVid = selected.getAttribute('data-new-variant');

    allChips.forEach(function (c) { c.classList.remove('is-selected'); });
    target.classList.add('is-selected');

    if (card) card.classList.add('fhc__card--swapping');
    allChips.forEach(function (c) { c.style.pointerEvents = 'none'; });

    postJSON('/cart/change.js', { id: lineKey, quantity: 0 }, function (err) {
      if (err) { window.location.reload(); return; }
      postJSON('/cart/add.js', { items: [{ id: parseInt(newVariant, 10), quantity: qty }] }, function (err2, addData) {
        if (err2) {
          if (originalVid) {
            postJSON('/cart/add.js', { items: [{ id: parseInt(originalVid, 10), quantity: qty }] }, function () { reloadCartSection(); });
          } else { window.location.reload(); }
          return;
        }

        var newKey = '';
        var newLinePrice = 0;
        var newUnitPrice = 0;
        if (addData && addData.items && addData.items[0]) {
          newKey = addData.items[0].key;
          newLinePrice = addData.items[0].final_line_price;
          newUnitPrice = addData.items[0].final_price;
        }

        if (newKey && card) {
          allChips.forEach(function (c) {
            c.setAttribute('data-line-key', newKey);
            c.style.pointerEvents = '';
          });
          card.querySelectorAll('[data-fhc-qty-minus], [data-fhc-qty-plus], [data-fhc-qty-input]').forEach(function (el) {
            el.setAttribute('data-line-key', newKey);
          });
          var removeBtn = card.querySelector('[data-fhc-remove]');
          if (removeBtn) removeBtn.setAttribute('data-line-key', newKey);

          var priceEl = card.querySelector('.fhc__price');
          if (priceEl && newLinePrice) priceEl.textContent = formatMoney(newLinePrice);

          var calcEl = card.querySelector('.fhc__qty-calc');
          if (qty > 1 && calcEl && newUnitPrice) {
            calcEl.textContent = qty + ' x ' + formatMoney(newUnitPrice);
          }
        }

        var isInBundle = card && card.closest('.fhc__group');
        if (isInBundle) {
          reloadCartSection();
        } else {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', '/cart.js', true);
          xhr.onload = function () {
            try {
              var cart = JSON.parse(xhr.responseText);
              updateCartUI(cart);
            } catch (e) {}
            if (card) card.classList.remove('fhc__card--swapping');
          };
          xhr.onerror = function () {
            if (card) card.classList.remove('fhc__card--swapping');
          };
          xhr.send();
        }
      });
    });
  }

  /* ============================================================
     GHOST CARD ADD
     ============================================================ */

  function reloadCartSection() {
    var xhr = new XMLHttpRequest();
    var sectionId = document.querySelector('[data-section-type="cart"]');
    var id = sectionId ? sectionId.getAttribute('data-section-id') : 'cart';
    xhr.open('GET', '/cart?sections=' + id, true);
    xhr.onload = function () {
      try {
        var sections = JSON.parse(xhr.responseText);
        var html = sections[id];
        if (html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var newCart = temp.querySelector('.cart__inner, [data-fhc-step="cart"]');
          var oldCart = document.querySelector('.cart__inner, [data-fhc-step="cart"]');
          if (newCart && oldCart) {
            oldCart.parentNode.replaceChild(newCart, oldCart);
          }
          var newAside = temp.querySelector('.fhc__aside-simple');
          var oldAside = document.querySelector('.fhc__aside-simple');
          if (newAside && oldAside) {
            oldAside.parentNode.replaceChild(newAside, oldAside);
          }
          var newMobile = temp.querySelector('.fhc__mobile-bar');
          var oldMobile = document.querySelector('.fhc__mobile-bar');
          if (newMobile && oldMobile) {
            oldMobile.parentNode.replaceChild(newMobile, oldMobile);
          }
          initAll();
        }
      } catch (e) {
        window.location.reload();
      }
    };
    xhr.onerror = function () { window.location.reload(); };
    xhr.send();
  }

  function handleBundleUpgrade(target) {
    var banner = target.closest('[data-fhc-upgrade]');
    var wrap = target.closest('[data-fhc-upgrade-wrap]');
    if (!banner || !wrap) return;
    var variantId = banner.getAttribute('data-upgrade-variant');
    var keysStr = wrap.getAttribute('data-upgrade-keys');
    if (!variantId || !keysStr) return;

    target.style.opacity = '0.5';
    target.style.pointerEvents = 'none';
    target.textContent = 'Oppgraderer...';

    var keys = keysStr.split(',').filter(function (k) { return k.length > 0; });
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });

    postJSON('/cart/update.js', { updates: updates }, function (err) {
      if (err) { window.location.reload(); return; }
      postJSON('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }] }, function (err2, cart) {
        if (err2) { window.location.reload(); return; }
        reloadCartSection();
      });
    });
  }

  function initBundleUpgrade() {
    var wraps = document.querySelectorAll('[data-fhc-upgrade-wrap]');
    wraps.forEach(function (wrap) {
      var mapRaw = wrap.getAttribute('data-upgrade-variant-map');
      var cartVidsRaw = wrap.getAttribute('data-upgrade-cart-variants');
      if (!mapRaw || !cartVidsRaw) return;

      var variantMap;
      try { variantMap = JSON.parse(mapRaw); } catch (e) { return; }
      var cartVids = cartVidsRaw.split(',').map(function (v) { return v.trim(); });

      var exactMatch = null;
      var largestVid = null;
      var largestPrice = 0;
      Object.keys(variantMap).forEach(function (bundleVid) {
        var entry = variantMap[bundleVid];
        var componentVids = Object.keys(entry.components);
        var allMatch = componentVids.every(function (cVid) {
          return cartVids.indexOf(cVid) !== -1;
        });
        if (allMatch) exactMatch = bundleVid;
      });

      var banners = wrap.querySelectorAll('[data-fhc-upgrade]');
      banners.forEach(function (b) {
        var price = parseInt(b.getAttribute('data-upgrade-price'), 10) || 0;
        if (price > largestPrice) { largestPrice = price; largestVid = b.getAttribute('data-upgrade-variant'); }
      });

      var showVid = exactMatch || largestVid;
      banners.forEach(function (b) {
        b.style.display = (showVid && b.getAttribute('data-upgrade-variant') === showVid) ? '' : 'none';
      });
    });
  }

  function handleGhostAdd(target) {
    var variantId = target.getAttribute('data-variant-id');
    if (!variantId) return;
    target.classList.add('is-adding');
    postJSON('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }] }, function (err) {
      if (err) { window.location.reload(); return; }
      reloadCartSection();
    });
  }

  /* ============================================================
     UPSELL ADD — AJAX add, checkmark, then reload
     ============================================================ */

  function handleUpsellAdd(target) {
    var variantId = target.getAttribute('data-variant-id');
    if (!variantId) return;

    target.classList.add('is-adding');

    postJSON('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }] }, function (err, data) {
      target.classList.remove('is-adding');

      if (err) { window.location.reload(); return; }

      target.classList.add('is-added');

      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', true);
      xhr.onload = function () {
        try {
          var cart = JSON.parse(xhr.responseText);
          updateCartUI(cart);
        } catch (e) {}
      };
      xhr.send();

      var card = target.closest('.fhc__mini, .fhc__ucard, .fhc__aside-upsell-card');
      if (card) {
        setTimeout(function () {
          card.style.transition = 'opacity 0.3s, transform 0.3s';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.9)';
          setTimeout(function () { reloadCartSection(); }, 300);
        }, 600);
      }
    });
  }

  /* ============================================================
     STEP TOGGLE — Cart ↔ Delivery
     ============================================================ */

  function showStep(stepName) {
    var cartStep = document.querySelector('[data-fhc-step="cart"]');
    var deliveryStep = document.querySelector('[data-fhc-step="delivery"]');
    var mobileBar = document.querySelector('[data-fhc-mobile-bar]');
    var siteFooter = document.querySelector('.site-footer, footer, .footer, #shopify-section-footer');
    var announcementBar = document.querySelector('.announcement-bar, #shopify-section-announcement-bar');

    if (!cartStep || !deliveryStep) return;

    if (stepName === 'delivery') {
      cartStep.classList.add('fhc__step--hidden');
      deliveryStep.classList.remove('fhc__step--hidden');
      if (mobileBar) mobileBar.style.display = 'none';
      if (siteFooter) siteFooter.style.display = 'none';
      if (announcementBar) announcementBar.style.display = 'none';
      document.body.classList.add('fhc--delivery-active');
      history.replaceState(null, '', '#bestilling');
    } else {
      deliveryStep.classList.add('fhc__step--hidden');
      cartStep.classList.remove('fhc__step--hidden');
      if (mobileBar) mobileBar.style.display = '';
      if (siteFooter) siteFooter.style.display = '';
      if (announcementBar) announcementBar.style.display = '';
      document.body.classList.remove('fhc--delivery-active');
      history.replaceState(null, '', window.location.pathname);
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if (window.location.hash === '#bestilling') {
    setTimeout(function () { showStep('delivery'); }, 100);
  }

  window.addEventListener('popstate', function () {
    if (window.location.hash === '#bestilling') showStep('delivery');
    else showStep('cart');
  });

  /* ============================================================
     EVENT DELEGATION
     ============================================================ */

  document.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== document.body) {
      if (target.hasAttribute) {
        if (target.hasAttribute('data-fhc-qty-minus'))    { e.preventDefault(); handleQtyChange(target, -1); return; }
        if (target.hasAttribute('data-fhc-qty-plus'))     { e.preventDefault(); handleQtyChange(target, 1);  return; }
        if (target.hasAttribute('data-fhc-swap'))          { e.preventDefault(); handleVariantSwap(target);   return; }
        if (target.hasAttribute('data-fhc-remove'))        { e.preventDefault(); handleRemove(target);        return; }
        if (target.hasAttribute('data-fhc-ghost-dismiss')) { e.preventDefault(); handleGhostDismiss(target);  return; }
        if (target.hasAttribute('data-fhc-bundle-dismiss')){ e.preventDefault(); handleBundleDismiss(target); return; }
        if (target.hasAttribute('data-fhc-ghost-add'))     { e.preventDefault(); handleGhostAdd(target);      return; }
        if (target.hasAttribute('data-fhc-upgrade-btn'))   { e.preventDefault(); handleBundleUpgrade(target); return; }
        if (target.hasAttribute('data-fhc-upsell-add'))    { e.preventDefault(); handleUpsellAdd(target);     return; }
        if (target.hasAttribute('data-fhc-goto-delivery')) { e.preventDefault(); showStep('delivery');        return; }
        if (target.hasAttribute('data-fhc-goto-cart'))     { e.preventDefault(); showStep('cart');             return; }
      }
      target = target.parentNode;
    }
  });

  /* ============================================================
     UPSELL RECOMMENDATIONS FALLBACK
     If no server-rendered upsell cards, load from Shopify recs API
     ============================================================ */

  function trimTitle(title) {
    var words = title.split(' ');
    var last = words[words.length - 1].toLowerCase();
    if (last === 'kg' && words.length > 2) return words.slice(0, -2).join(' ');
    return title;
  }

  function buildMiniCardHTML(p) {
    var v = p.variants[0];
    var title = trimTitle(p.title);
    var price = formatMoney(parseInt(v.price, 10));
    var img = p.featured_image || (p.images && p.images[0] ? p.images[0].src || p.images[0] : '');
    if (img && img.indexOf('?') > -1) img += '&width=400&height=400&crop=center';
    else if (img) img += '?width=400&height=400&crop=center';
    var url = p.url || '/products/' + p.handle;

    var weight = (v.title && v.title !== 'Default Title') ? v.title : '';

    var html = '<div class="fhc__mini" data-product-id="' + p.id + '">';
    html += '<a href="' + url + '" class="fhc__mini-img-link">';
    if (img) {
      html += '<img class="fhc__mini-img" src="' + img + '" alt="' + title.replace(/"/g, '&quot;') + '" width="200" height="200" loading="lazy">';
    } else {
      html += '<div class="fhc__mini-img fhc__mini-img--placeholder"></div>';
    }
    html += '</a>';
    html += '<div class="fhc__mini-body">';
    html += '<a href="' + url + '" class="fhc__mini-name">' + title + '</a>';
    if (weight) html += '<span class="fhc__mini-weight">' + weight + '</span>';
    html += '<div class="fhc__mini-bottom"><div class="fhc__mini-prices">';
    html += '<span class="fhc__mini-price">' + price + '</span>';
    html += '</div>';
    html += '<button type="button" class="fhc__mini-add" data-fhc-upsell-add data-variant-id="' + v.id + '" aria-label="Legg til ' + title.replace(/"/g, '&quot;') + '">';
    html += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
    html += '</button></div></div></div>';
    return html;
  }

  /* ---- Prisbevisst komplementaer-upsell (Viktor 2026-08-20) ----
     Priser fra recommendations-API er i ORE (parseInt gir ore). Terskler i ore. */
  var FH_UPSELL_EXPENSIVE = 80000;   /* 800 kr: en vare sa dyr = kunden aksepterer hoyt prisniva */
  var FH_UPSELL_HIGHCART = 200000;   /* 2000 kr: hoy kurv = komfortabel med pris */
  var FH_UPSELL_FLOOR = 60000;       /* 600 kr: laveste pristak, sa vi ikke bare viser smavarer */
  var _fhCartSignal = null;
  function fhGetCartSignal(cb) {
    if (_fhCartSignal) { cb(_fhCartSignal); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onload = function () {
      var sig = { subtotal: 0, maxItem: 0 };
      try {
        var c = JSON.parse(xhr.responseText);
        sig.subtotal = c.total_price || 0;
        (c.items || []).forEach(function (it) { if ((it.price || 0) > sig.maxItem) sig.maxItem = it.price; });
      } catch (e) {}
      _fhCartSignal = sig; cb(sig);
    };
    xhr.onerror = function () { _fhCartSignal = { subtotal: 0, maxItem: 0 }; cb(_fhCartSignal); };
    xhr.send();
  }
  /* Prov complementary (kjopt-sammen) forst; fall tilbake til related om ukonfigurert/tomt */
  function fhFetchRecs(pid, limit, cb) {
    function get(u, next) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', u, true);
      xhr.onload = function () { try { next(JSON.parse(xhr.responseText).products || []); } catch (e) { next([]); } };
      xhr.onerror = function () { next([]); };
      xhr.send();
    }
    var base = '/recommendations/products.json?product_id=' + pid + '&limit=' + limit;
    get(base + '&intent=complementary', function (comp) {
      if (comp && comp.length) cb(comp);
      else get(base, function (rel) { cb(rel || []); });
    });
  }
  function fhPriceOf(p) { return (p.variants && p.variants[0]) ? (parseInt(p.variants[0].price, 10) || 0) : 0; }
  /* Ikke lede med det dyreste; lofte prisen nar kunden har signalisert aksept (dyr vare i kurv / hoy kurv) */
  function fhPickPriceAware(candidates, signal, count) {
    var pool = candidates.slice();
    var signalled = signal.maxItem >= FH_UPSELL_EXPENSIVE || signal.subtotal >= FH_UPSELL_HIGHCART;
    if (signalled) {
      pool.sort(function (a, b) { return fhPriceOf(b) - fhPriceOf(a); }); /* vis premium-komplementer forst */
    } else {
      var ceil = Math.max(signal.maxItem, FH_UPSELL_FLOOR);
      var within = pool.filter(function (p) { return fhPriceOf(p) <= ceil; });
      if (within.length >= count) pool = within;                              /* nok rimelige: behold relevans-rekkefolge */
      else pool.sort(function (a, b) { return fhPriceOf(a) - fhPriceOf(b); }); /* ellers billigst forst, aldri lede med dyreste */
    }
    return pool.slice(0, count);
  }
  /* Samme prisregel pa allerede-rendrede kort (inkl. manuelt kuraterte via metafelt): reorder, aldri skjul.
     Modest kurv -> billigst forst (aldri lede med det dyreste). Signalisert (dyr vare/hoy kurv) -> dyrest forst. */
  function fhReorderStrip(container) {
    if (!container) return;
    var cards = Array.prototype.slice.call(container.querySelectorAll('.fhc__mini'));
    if (cards.length < 2) return;
    fhGetCartSignal(function (signal) {
      var signalled = signal.maxItem >= FH_UPSELL_EXPENSIVE || signal.subtotal >= FH_UPSELL_HIGHCART;
      function cardPrice(el) {
        var node = el.querySelector('.fhc__mini-price');
        var digits = (node ? node.textContent : '').replace(/[^0-9]/g, '');
        return digits ? parseInt(digits, 10) : 0; /* "199,00 kr" -> 19900 (ore) */
      }
      cards.sort(function (a, b) { return signalled ? cardPrice(b) - cardPrice(a) : cardPrice(a) - cardPrice(b); });
      cards.forEach(function (c) { container.appendChild(c); });
    });
  }

  function loadUpsellRecs() {
    var section = document.querySelector('[data-fhc-upsell]');
    if (!section) return;
    var scroll = section.querySelector('[data-fhc-upsell-scroll]');
    if (!scroll) return;
    if (scroll.children.length > 0) return;

    var pids = (section.dataset.cartPids || '').split(',').filter(Boolean);
    if (pids.length === 0) return;

    var ghostPids = (section.dataset.ghostPids || '').split(',').filter(Boolean);

    var seen = {};
    pids.forEach(function (id) { seen[id] = true; });
    ghostPids.forEach(function (id) { seen[id] = true; });
    var toFetch = pids.slice(0, 3);

    fhGetCartSignal(function (signal) {
      var allRecs = [];
      var done = 0;
      toFetch.forEach(function (pid) {
        fhFetchRecs(pid, 6, function (products) {
          done++;
          products.forEach(function (p) {
            if (!seen[p.id]) { seen[p.id] = true; allRecs.push(p); }
          });
          if (done === toFetch.length) {
            renderRecs(section, scroll, fhPickPriceAware(allRecs, signal, 6));
          }
        });
      });
    });
  }

  function renderRecs(section, scroll, recs) {
    if (recs.length === 0) return;
    var html = '';
    recs.slice(0, 6).forEach(function (p) {
      html += buildMiniCardHTML(p);
    });
    scroll.innerHTML = html;
    section.classList.add('is-loaded');
  }

  /* ============================================================
     ASIDE UPSELL FALLBACK
     If no server-rendered aside upsell, grab first rec from API
     ============================================================ */

  function loadAsideUpsell() {
    var aside = document.querySelector('[data-fhc-aside-upsell]');
    if (!aside) return;
    var list = aside.querySelector('[data-fhc-aside-upsell-list]');
    if (!list) return;
    var existing = list.querySelectorAll('.fhc__mini').length;
    if (existing >= 2) return;

    var pids = (aside.dataset.cartPids || '').split(',').filter(Boolean);
    if (pids.length === 0) return;

    var seen = {};
    pids.forEach(function (id) { seen[id] = true; });
    list.querySelectorAll('[data-product-id]').forEach(function (el) {
      seen[el.dataset.productId] = true;
    });

    var needed = 2 - existing;
    fhGetCartSignal(function (signal) {
      fhFetchRecs(pids[0], 8, function (products) {
        var candidates = products.filter(function (p) { return !seen[p.id]; });
        var picks = fhPickPriceAware(candidates, signal, needed);
        picks.forEach(function (p) { renderAsideUpsell(list, p); });
        if (picks.length > 0) aside.classList.remove('fhc__aside-upsell--empty');
      });
    });
  }

  function renderAsideUpsell(container, p) {
    container.insertAdjacentHTML('beforeend', buildMiniCardHTML(p));
  }

  function setAdaptiveGrid() {
    var content = document.querySelector('.cart__content');
    if (!content) return;
    var items = document.querySelectorAll('cart-items .fhc__card, cart-items .fhc__group');
    var count = items.length;
    if (count <= 2) {
      content.classList.add('fhc__grid-single');
    } else {
      content.classList.remove('fhc__grid-single');
    }
  }

  function restoreDismissedBundles() {
    document.querySelectorAll('.fhc__group[data-bundle-id]').forEach(function (group) {
      var bid = group.dataset.bundleId;
      try {
        if (sessionStorage.getItem('fhc_dismissed_' + bid) === '1') {
          cleanupBundleGroup(group);
        }
      } catch (e) {}
    });
  }

  function initUpsells() {
    loadUpsellRecs();
    loadAsideUpsell();
    setAdaptiveGrid();
    restoreDismissedBundles();
    /* prisbevisst rekkefolge pa server-rendrede (kuraterte) upsell-strimler */
    fhReorderStrip(document.querySelector('[data-fhc-upsell-scroll]'));
    fhReorderStrip(document.querySelector('[data-fhc-aside-upsell-list]'));
  }

  function initAll() {
    initUpsells();
    initBundleUpgrade();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
